// src/utils/getUserNameFromToken.js
import { tokenStore } from "../services/tokenStore";

function decodeJwtPayload(token) {
  const part = token.split(".")[1];
  if (!part) return null;

  // base64url -> base64
  let b64 = part.replace(/-/g, "+").replace(/_/g, "/");
  // паддинг
  while (b64.length % 4) b64 += "=";

  try {
    const json = atob(b64);
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export const getUserNameFromToken = () => {
  const token = tokenStore.get();
  if (!token) return "Аноним";

  const payload = decodeJwtPayload(token);
  if (!payload || typeof payload !== "object") return "Аноним";

  // возможные клеймы с именем
  return (
    payload.name ||
    payload.unique_name ||
    payload.preferred_username ||
    payload.nickname ||
    payload.sub ||
    "Аноним"
  );
};

export const decodeUserId = (tok) => {
  if (!tok) return null;
  try {
    let part = tok.split(".")[1] || "";
    part = part.replace(/-/g, "+").replace(/_/g, "/");
    while (part.length % 4) part += "=";
    const p = JSON.parse(atob(part));
    return (
      p["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"] ||
      p.sub ||
      null
    );
  } catch {
    return null;
  }
};
